import { Image, Message, Table, List, Checkbox, Segment } from 'semantic-ui-react';
import logo from '../../assets/logo.png';
import { useSelector, useDispatch } from 'react-redux';
//import {Document,Page,View,Image,Text,Link,Font,StyleSheet} from '@react-pdf/renderer';

const DeMinimis = () => {

    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);
    const displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    const getProjectTitle = () => {
        let title = '';
        projectState.project.title.forEach(item => {
            if (item.translation !== '') {
                title = item.translation + ' - ' + item.language;
            }
            if (item.language === 'EN' && item.translation !== '') {
                title = item.translation;
            }
        });
        return (title);
    }

    const renderProjectDescription = () => {
        return (
            <Table celled>
                <Table.Body>
                    <Table.Row key="0-1">
                        <Table.Cell width="4">Project Number</Table.Cell>
                        <Table.Cell>{projectState.project.customIdentifier}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-2">
                        <Table.Cell >Project Acronym</Table.Cell>
                        <Table.Cell>{projectState.project.acronym}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-3">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-4">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-5">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-6">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }


    // return (
    //     <Document>            
    //         <Page size="A4">
    //             <Image src={logo}/>
    //             <Text>
    //                 De minimis award letter
    //             </Text>
    //         </Page>
    //     </Document>
    // );


    return (
        <div className='margin-report-1'>
            <table>
                <thead>
                    <tr>
                        <th><Image src={logo} size='medium' /></th>
                    </tr>
                </thead>
                <tbody >
                    <tr className='page-break full-width'>
                        <td>
                            <h2 className='title'>De minimis award letter</h2>
                            <h3 className='title'>In accordance with Commission Regulation (EU) No 1407/2013</h3>
                            <p>for the organization</p>
                            <p>
                                participating in the project NWE917 CircTex co-financed by North West Europe Programme - hereinafter referred to as de minimis recipient.
                            </p>
                            <p>
                                The de minimis recipient is granted de minimis aid within the meaning of Commission Regulation (EU) No 1407/2013 of 18 December 2013 on the application of Article 107 and 1 08 of the TFEU to de minimis aid l . In accordance with Article 3(2) of that regulation the maximum total amount of de minimis aid granted per Member State to a single undertaking - as defined by Article 2(2) of that regulation - shall not exceed EUR 200,000 during the current fiscal year and the previous two fiscal years. The total amount of de minimis aid granted per Member State to a single undertaking performing road freight transport for hire or reward shall not exceed EUR 100,000 during the current fiscal year and the previous two fiscal years.
                            </p>
                            <p>
                                On 28 May 2019{/* De minimis signature Date */} the de minimis recipient provided a de minimis declaration about any other de minimis aid received during the current fiscal year and the previous two fiscal years. Further in this declaration the de minimis recipient confirmed compliance with the requirements of Commission Regulation (EU) No 1407/2013.
                            </p>
                            <p>
                                As a result, the de minimis recipient is granted de minimis aid within the meaning of Commission Regulation (EU) No 1407/2013 amounting to EUR 38.550,00{/* De minimis Amount*/} (gross grant equivalent: EUR 38.550,00{/* De minimis Amount*/}). The aid is granted to the de minimis recipient through the subsidy contract of the project {/* Project Number + Acronym*/}NWE917 CircTex concluded on {/*signature Date*/}22 January 2020 (= date of signature of the subsidy contract) between the Région Hauts-de-France - acting as the managing authority of the European territorial cooperation programme Interreg North West Europe - and the lead partner of the project.
                            </p>
                            <p>
                                The aid was granted by the following Member States:
                            </p>
                            <p>
                                Belgium (EUR 6.425,00)
                                France (EUR 6.425,00)
                                Germany (EUR 6.425,00)
                                Ireland (EUR 6.425,00)
                                The Netherlands (EUR 6.425,00)
                                The United Kingdom (EUR 6.425,00)
                            </p>
                            <p>
                            This de minimis award letter   
                            shall be kept available for 10 fiscal years from the date on which the aid was granted (i.e. signature of the subsidy contract)   
                            shall be provided on request of the EU Commission, the Member States participating in the North West Europe Programme, the responsible auditing bodies of the EU and, within their responsibility, the auditing bodies of the participating EU Member States or other national public auditing bodies or an external auditor designated by the programme bodies, as well as the Audit Authority of the programme, the Group of Auditors of the programme and the managing authority or joint secretariat within a period of 1 0 working days or such longer period as may be fixed in the request. 
                            shall be considered for future applications for any de minimis aid of the de minimis recipient acting as a single undertaking - as defined by Article 2(2) of Commission Regulation (EU) No 1407/2013.
                            </p>
                            <p>For the managing authority of the European territorial cooperation programme</p>
                            <p>Interreg North West Europe:</p>
                            {renderProjectDescription()}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

}

export default DeMinimis;